module.exports = __webpack_public_path__ + "static/media/tlyfeDesktop.099f0a9d.png";